import { useEffect } from "react";
import { api } from "../api/client";

// Heartbeat automático: enquanto o freteiro está online, envia ping a cada 30s
// com lat/lng atual. Primeiro ping é atrasado em 1.5s pra dar tempo do
// POST /online completar (caso contrário backend retorna 409 "está offline").
//
// Backend marca o freteiro como offline automaticamente após 90s sem
// heartbeat (ver freteiro_offline_job no backend).
export const useFreteiroHeartbeat = (online) => {
  useEffect(() => {
    if (!online) return;
    let pingEmCurso = false;
    let cancelado = false;
    const ping = () => {
      if (pingEmCurso || cancelado) return;
      pingEmCurso = true;
      try {
        if (!navigator.geolocation) { pingEmCurso = false; return; }
        navigator.geolocation.getCurrentPosition(async (pos) => {
          if (cancelado) { pingEmCurso = false; return; }
          try {
            await api.fetch('/usuarios/me/freteiro/heartbeat', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                lat: pos.coords.latitude,
                lng: pos.coords.longitude,
                precisao_m: pos.coords.accuracy || null,
              }),
            });
          } catch {}
          pingEmCurso = false;
        }, () => { pingEmCurso = false; }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 30000 });
      } catch { pingEmCurso = false; }
    };
    // Primeiro tiro com 1.5s de atraso (race com POST /online)
    const t0 = setTimeout(ping, 1500);
    const iv = setInterval(ping, 30000);
    return () => { cancelado = true; clearTimeout(t0); clearInterval(iv); };
  }, [online]);
};
